module.exports = __webpack_public_path__ + "static/media/linkedIn.6d8dc52a.svg";